import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faCalendar, faChartLine, faTrophy, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { Modal } from './Modal';
import './HelpModal.css';

export const HistoryHelpModal: React.FC<{ isOpen: boolean; onClose: () => void; }> = ({ isOpen, onClose }) => (
    <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
        <h2><FontAwesomeIcon icon={faHistory} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />History Guide</h2>
        <p style={{ fontSize: '1.1em', marginBottom: '24px' }}>Review past seasons and match results. Analyze your progress and track your managerial journey.</p>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faChartLine} style={{ marginRight: '8px', color: 'var(--info-color)' }} />Season Records</h3>
            <p><strong>Overview of each completed season:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Season Number:</strong> Which season (1, 2, 3, etc.)</li>
                <li><strong>League:</strong> Which division you finished in</li>
                <li><strong>Final Position:</strong> Where you finished in the league</li>
                <li><strong>Record:</strong> Wins, draws, losses (W-D-L)</li>
                <li><strong>Points:</strong> Total league points earned</li>
                <li><strong>Goals:</strong> Goals scored and conceded</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Review past seasons to identify patterns and areas for improvement</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faTrophy} style={{ marginRight: '8px', color: 'var(--accent-text-color)' }} />Achievements</h3>
            <p><strong>Major accomplishments across your career:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>League Titles:</strong> When you won the league championship</li>
                <li><strong>Promotions:</strong> Seasons when you got promoted to higher divisions</li>
                <li><strong>Cup Victories:</strong> Cup competitions you've won</li>
                <li><strong>Records:</strong> Best and worst seasons</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faCalendar} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Match Results</h3>
            <p><strong>Detailed match information:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Opponent:</strong> Which team you played</li>
                <li><strong>Score:</strong> Final result of the match</li>
                <li><strong>Date:</strong> When the match was played</li>
                <li><strong>Competition:</strong> League or cup match</li>
                <li><strong>Performance:</strong> Team rating for that match</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Analysis Tips</h3>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>Compare goal-scoring records across seasons to identify trends</li>
                <li>Analyze defensive performance (goals conceded) to improve structure</li>
                <li>Look for patterns in losses - are they against specific team types?</li>
                <li>Track promotion progress and timing across different leagues</li>
                <li>Identify your best and worst performing seasons to understand what worked</li>
                <li>Use historical data to set realistic targets for future seasons</li>
                <li>Monitor consistency - steady improvement is better than volatile performance</li>
            </ul>
        </div>

        <div className="modal-actions">
            <button className="button primary" onClick={onClose}>Got it!</button>
        </div>
    </Modal>
);
